<template>
  <div class="sf-traders">
    <div class="sf-traders-grid">
      <div
        v-for="item in dataList"
        :key="item.id"
        class="sf-trader-card"
        :class="{ following: item.possuiAssinatura }"
      >
        <!-- header -->
        <div class="sf-trader-head">
          <div class="sf-trader-avatar">
            {{ (item.nome || '').substring(0, 2).toUpperCase() }}
          </div>
          <div class="sf-trader-idcol">
            <div class="sf-trader-name">
              {{ item.nome }}
            </div>
            <div
              v-if="item.descricao"
              class="sf-trader-desc"
            >
              {{ item.descricao }}
            </div>
          </div>
          <span
            v-if="item.possuiAssinatura"
            class="sf-trader-following"
          >Seguindo</span>
        </div>

        <!-- métricas -->
        <div
          v-if="item.sinalMetrica"
          class="sf-trader-metrics"
        >
          <div class="sf-tr-metric">
            <span class="sf-eyebrow">{{ $t('spot.meuAgente.taxaacerto') }}</span>
            <span
              class="sf-tr-val sf-tr-lg"
              :class="parseFloat(item.sinalMetrica.totalGanhoPercent) > 0 ? 'sf-up' : ''"
            >{{ parseFloat(item.sinalMetrica.totalGanhoPercent || 0).toFixed(1) }}%</span>
          </div>
          <div class="sf-tr-metric">
            <span class="sf-eyebrow">{{ $t('Sinais') }}</span>
            <span class="sf-tr-val sf-tr-lg">{{ item.sinalMetrica.total }}</span>
          </div>
          <div class="sf-tr-metric">
            <span class="sf-eyebrow">{{ $t('spot.meuAgente.comissao') }}</span>
            <span class="sf-tr-val">{{ item.taxaDesempenho ? item.taxaDesempenho + '%' : '—' }}</span>
          </div>
          <div class="sf-tr-metric">
            <span class="sf-eyebrow">{{ $t('spot.meuAgente.paridade') }}</span>
            <span class="sf-tr-val sf-tr-pairs">
              <span
                v-for="(par, i) in (item.paridades || 'USDT').split(',')"
                :key="i"
                class="sf-tr-pair"
              >{{ par.trim() }}</span>
            </span>
          </div>
        </div>

        <!-- rodapé -->
        <div class="sf-trader-actions">
          <button
            v-if="item.possuiAssinatura"
            type="button"
            class="sf-tr-btn sf-tr-btn-config"
            @click.stop="editData(item.id)"
          >
            {{ $t('spot.meuAgente.configurarBtn') }}
          </button>
          <button
            v-else
            v-b-modal.modal-assinar-agente
            type="button"
            class="sf-tr-btn sf-tr-btn-follow"
            @click.stop="modalSeguirAgente = item"
          >
            {{ $t('spot.meuAgente.SeguirBtn') }}
          </button>
          <button
            type="button"
            class="sf-tr-btn sf-tr-btn-ghost"
            @click.stop="$router.push(`/futures/relatorio/sinal?agente=${item.id}&periodo=3m`).catch(() => {})"
          >
            {{ $t('spot.meuAgente.operacaoesBtn') }}
          </button>
        </div>
      </div>
    </div>

    <b-modal
      v-if="modalSeguirAgente"
      id="modal-assinar-agente"
      ref="modal-assinar-agente"
      cancel-variant="outline-secondary"
      :ok-title="$t('spot.meuAgente.SeguirBtn')"
      :cancel-title="$t('futures.agente.assinante.sair')"
      :title="$t('spot.meuAgente.seguirAgente')"
      hide-header-close
      centered
      no-close-on-backdrop
      @ok="assinarAgente(modalSeguirAgente.id)"
    >
      <h2>{{ $t('spot.meuAgente.SeguirTextoConfirmacao') }} <strong>{{ modalSeguirAgente.nome }}</strong> ?</h2>
    </b-modal>
  </div>
</template>

<script>

import { VBTooltip } from 'bootstrap-vue'
import store from '@/store'
import utilsMixin from '@/mixins/utilsMixin'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import meuAgenteStoreModule from './meuAgenteStoreModule'

const MEU_AGENTE_FUT_STORE_MODULE_NAME = 'meu-agente-fut'

export default {

  components: {},

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  mixins: [utilsMixin],

  data() {
    return {
      dataList: [],
      modalSeguirAgente: null,
    }
  },

  created() {
    if (!store.hasModule(MEU_AGENTE_FUT_STORE_MODULE_NAME)) store.registerModule(MEU_AGENTE_FUT_STORE_MODULE_NAME, meuAgenteStoreModule)
    this.fetchList()
  },

  beforeDestroy() {
    if (store.hasModule(MEU_AGENTE_FUT_STORE_MODULE_NAME)) store.unregisterModule(MEU_AGENTE_FUT_STORE_MODULE_NAME)
  },

  methods: {

    getStatusColor(value) {
      let cortemp = ''
      if (value === 'Ativo') {
        cortemp = 'success'
      } else if (value === 'Inativo') {
        cortemp = 'danger'
      } else if (value === 'Expirado') {
        cortemp = 'danger'
      }
      return cortemp
    },

    assinarAgente(id) {
      store
        .dispatch('meu-agente-fut/assinarAgente', id)
        .then(() => {
          this.editData(id)
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao assinar.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },

    editData(id) {
      this.$router.push(`/futures/meu-agente/${id}`).catch(() => {})
    },

    getlogo(id) {
      return `${process.env.VUE_APP_STATIC}agente/${id}/logo.png`
    },

    fetchList() {
      store
        .dispatch('meu-agente-fut/getMeuAgente')
        .then(response => {
          this.dataList = response.data
          if (this.dataList.length === 1 && this.dataList[0].possuiAssinatura === true) {
            this.$router.push({ name: 'fut-meu-agente-edit', params: { id: this.dataList[0].id } })
          }
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao recuperar a lista.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },

}
</script>

<style lang="scss" scoped>
/* ============================================================
   Meus Traders — grid de cards (redesign Soulf).
   Tokens em src/assets/scss/soulf-theme.scss (:root --sf-*).
   ============================================================ */
.sf-traders { padding: 4px 0 24px; }

.sf-traders-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  gap: 16px;
}

.sf-trader-card {
  background: var(--sf-card);
  border: 1px solid var(--sf-border);
  border-radius: 16px;
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 18px;

  &.following { border-color: var(--sf-border-strong); }
}

/* header */
.sf-trader-head {
  display: flex;
  align-items: center;
  gap: 12px;

  .sf-trader-avatar {
    flex-shrink: 0;
    width: 42px; height: 42px;
    display: flex; align-items: center; justify-content: center;
    border-radius: 11px;
    background: var(--sf-elev);
    border: 1px solid var(--sf-border);
    color: var(--sf-accent);
    font-family: 'Geist Mono','SFMono-Regular',Menlo,monospace;
    font-size: 13px; font-weight: 600;
  }
  .sf-trader-idcol { flex: 1; min-width: 0; }
  .sf-trader-name {
    font-family: 'Geist',sans-serif; font-weight: 600; font-size: 15px; color: var(--sf-fg);
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .sf-trader-desc {
    font-size: 12px; color: var(--sf-fg-4); margin-top: 2px;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .sf-trader-following {
    flex-shrink: 0;
    font-size: 10px; font-weight: 600;
    color: var(--sf-green);
    background: rgba(34,197,94,0.12);
    border-radius: 6px;
    padding: 3px 8px;
  }
}

/* painel de métricas */
.sf-trader-metrics {
  background: var(--sf-card-2);
  border: 1px solid var(--sf-border-subtle);
  border-radius: 12px;
  padding: 16px 18px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 14px;

  .sf-tr-metric { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
  .sf-tr-val {
    font-family: 'Geist Mono','SFMono-Regular',Menlo,monospace;
    font-variant-numeric: tabular-nums;
    font-size: 15px; color: var(--sf-fg-3);
  }
  .sf-tr-lg { font-size: 18px; color: var(--sf-fg); }
  .sf-tr-pairs { display: flex; flex-wrap: wrap; gap: 4px; }
  .sf-tr-pair {
    font-family: 'Geist',sans-serif; font-size: 11px; font-weight: 500;
    color: var(--sf-fg-2);
    background: var(--sf-elev);
    border: 1px solid var(--sf-border);
    border-radius: 5px;
    padding: 1px 6px;
  }
}

/* rodapé */
.sf-trader-actions {
  display: flex;
  gap: 8px;

  .sf-tr-btn {
    flex: 1;
    padding: 9px 0;
    border-radius: 8px;
    font-family: 'Geist',sans-serif;
    font-weight: 600;
    font-size: 12px;
    cursor: pointer;
    border: 1px solid transparent;
    transition: background .15s ease, border-color .15s ease, transform .12s ease;

    &:hover { transform: translateY(-1px); }
  }
  .sf-tr-btn-follow { background: var(--sf-accent); color: #fff; }
  .sf-tr-btn-config {
    background: var(--sf-code);
    border-color: var(--sf-border);
    color: var(--sf-fg-3);
    &:hover { color: #fff; }
  }
  .sf-tr-btn-ghost {
    background: transparent;
    border-color: var(--sf-border);
    color: var(--sf-fg-3);
    &:hover { color: #fff; background: rgba(255,255,255,0.04); }
  }
}

.sf-up { color: var(--sf-green) !important; }
.sf-down { color: var(--sf-red) !important; }
</style>
